<div class="hover-details-vehicle" (click)="toggleDetails($event)">
  <div class="title_container">
    <i [class.icon_rotate]="isOpen" class="fas fa-chevron-right"></i>
    <h4>{{ titleSummary }}</h4>
  </div>
  <ng-content *ngIf="isOpen"></ng-content>
</div>
